import React from 'react';

const NewsTicker = ({ marketNews, marketStatus, lastUpdated }) => {
  const isMarketClosed = marketStatus?.status !== 'open';
  
  // Format the last updated time in user's local timezone
  const formatLastUpdated = () => {
    if (!lastUpdated) return '';
    // Parse the date - if it's ISO format without timezone, append 'Z' to treat as UTC
    let dateStr = lastUpdated;
    if (!dateStr.includes('Z') && !dateStr.includes('+') && !dateStr.includes('-', 10)) {
      dateStr = dateStr + 'Z';  // Treat as UTC
    }
    const date = new Date(dateStr);
    // toLocaleString will automatically convert to user's local timezone
    return date.toLocaleString('en-US', {
      weekday: 'short',
      month: 'short', 
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZoneName: 'short'  // Add timezone indicator for clarity
    });
  };

  if (!marketNews || marketNews.length === 0) {
    // Still show the market status even if no news (desktop only)
    return (
      <div className="hidden sm:block absolute top-20 left-52 right-64 bg-slate-900/90 rounded-lg px-4 py-2 overflow-hidden z-10 border border-slate-700">
        <div className="flex items-center justify-between">
          {isMarketClosed && (
            <span className="text-amber-400 text-xs font-medium">
              ⚠️ Market closed — Last trading session data
            </span>
          )}
          {lastUpdated && (
            <span className="text-slate-500 text-[10px]">
              Last Updated: {formatLastUpdated()}
            </span>
          )}
        </div>
      </div>
    );
  }

  // Triple the news for seamless infinite scroll
  const tripleNews = [...marketNews, ...marketNews, ...marketNews];

  return (
    <div className="hidden sm:block absolute top-20 left-52 right-64 bg-slate-900/90 rounded-lg px-4 py-1.5 overflow-hidden z-10 border border-slate-700">
      {/* Market Status & Last Updated */}
      <div className="flex items-center justify-between mb-1 pb-1 border-b border-slate-700">
        {isMarketClosed ? (
          <span className="text-amber-400 text-xs font-medium">
            ⚠️ Market closed — Last trading session data
          </span>
        ) : (
          <span className="text-emerald-400 text-xs font-medium">
            🟢 Market Open
          </span>
        )}
        {lastUpdated && (
          <span className="text-slate-500 text-[10px]">
            Updated: {formatLastUpdated()}
          </span>
        )}
      </div>
      {/* Scrolling News */}
      <div 
        className="flex whitespace-nowrap items-center animate-ticker hover:[animation-play-state:paused]"
        style={{ width: 'max-content' }}
      >
        {tripleNews.map((news, i) => (
          <span key={i} className="text-sm text-slate-200 mx-6 font-medium inline-flex items-center">
            {news.category && (
              <span className="text-amber-400 font-bold mr-2 text-xs">{news.category}</span>
            )}
            <span className="hover:text-amber-300 cursor-pointer">{news.headline}</span>
            <span className="text-slate-500 ml-2 text-xs">• {news.source}</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default NewsTicker;
